import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';

const TrackerStatus = ({items}) => {
    if (items.some(({type}) => type === constants.TRACKER_MESSAGE_TYPES.REMINDER)) {
        return <span className="badge badge-warning"><FormattedMessage {...messages.trackers.list.reminderSent} /></span>;
    }
    if (items.some(({type}) => type === constants.TRACKER_MESSAGE_TYPES.INVITATION)) {
        return <span className="badge badge-info"><FormattedMessage {...messages.trackers.list.inviteSent} /></span>;
    }
    return null;
};

export default TrackerStatus;
